// Treat empty Tiptap content (`<p></p>`) as no change when there was no prior
// value, so we don't write a meaningless empty paragraph to the DB.
export const normalizeRichText = (
  next: string | null | undefined,
  prev: string | null | undefined,
): string | null => {
  const trimmed = next?.trim() || null;
  const isEmptyTiptap = trimmed === '<p></p>';
  const hadValue = !!prev;
  return isEmptyTiptap && !hadValue ? null : trimmed;
};
